module.exports = __webpack_public_path__ + "img/new-work-tasks.be9906dd.svg";